<script setup lang="ts">
import { ref } from 'vue'
import { useDisplay } from 'vuetify'
import { useCookies } from '@vueuse/integrations/useCookies'
import { useUserStore } from '@/stores/user'
import { useRouter } from 'vue-router'
import { endShift } from '@/api/shifts/endShift'
const { setUser } = useUserStore()
const { mdAndUp } = useDisplay()

const router = useRouter()

const { remove } = useCookies(['token'])

const logoutDialog: any = defineModel()
const endingCash = ref('')
const endShiftDialog = ref(false)
const summaryDialog = ref(false)
const starting_cash_amount = ref('')
const total_completed_cash = ref('')
const total_completed_visa = ref('')
const loading = ref(false)

const logout = () => {
  remove('token')
  localStorage.removeItem('userAbilities')
  setUser(null)
  router.push('/login')
}

const endAndLogout = async () => {
  loading.value = true
  const { data } = await endShift(endingCash.value)
  loading.value = false
  if (data) {
    starting_cash_amount.value = data.starting_cash_amount
    total_completed_cash.value = data.total_completed_cash
    total_completed_visa.value = data.total_completed_visa
  }
  remove('token')
  localStorage.removeItem('userAbilities')
  setUser(null)
  summaryDialog.value = true
}
</script>

<template>
  <v-dialog v-model="logoutDialog" :fullscreen="!mdAndUp ? true : false" max-width="500px">
    <v-card>
      <v-icon icon="mdi-close" @click="logoutDialog = false" style="margin: 10px 16px"></v-icon>

      <v-card-actions class="d-flex justify-center">
        <v-btn color="primary" style="letter-spacing: 0" variant="elevated" @click="logout"
          >تسجيل الخروج</v-btn
        >
        <v-btn
          color="primary"
          variant="elevated"
          style="letter-spacing: 0"
          @click="endShiftDialog = true"
          >انهاء الوردية وتسجيل الخروج</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="endShiftDialog" :fullscreen="!mdAndUp ? true : false" max-width="500px">
    <v-card>
      <v-icon icon="mdi-close" @click="endShiftDialog = false" style="margin: 10px 16px"></v-icon>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="endingCash"
              rounded-md
              variant="outlined"
              label="قيمة الكاش الحالية"
              density="compact"
              type="number"
              color="primary"
            />
          </v-col>

          <!-- 👉 submit button -->
          <v-col cols="12">
            <v-btn
              color="primary"
              block
              size="large"
              style="letter-spacing: 0"
              :disabled="endingCash == ''"
              :loading="loading"
              @click="endAndLogout"
              >انهاء وردية العمل</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>

  <v-dialog v-model="summaryDialog" :fullscreen="!mdAndUp ? true : false" max-width="500px">
    <v-card>
      <v-icon icon="mdi-close" @click="router.push('/login')" style="margin: 10px 16px"></v-icon>

      <v-card-text class="d-flex justify-center text-h6">
        قيمة الكاش الابتدائية: {{ starting_cash_amount }} <br />
        قيمة الكاش المكتملة: {{ total_completed_cash }} <br />
        قيمة الفيزا المكتملة: {{ total_completed_visa }}
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
